import { Reference } from '@volkswagen-onehub/disclaimer-manager/dist-es/api';

export interface RegisteredDisclaimers {
	[key: string]: RegisteredDisclaimer;
}

export interface NamedDisclaimer {
	readonly ref: string;
	readonly text: string;
}

export interface RegisteredDisclaimer {
	readonly text: string;
	readonly ref: Reference | undefined;
	readonly type: 'legal' | 'legal cuota';
	readonly onClick?: () => void;
}

export type DisclaimerType = string | NamedDisclaimer;

export const getDisclaimerText = (disclaimer: DisclaimerType): string | undefined => {
	return typeof disclaimer === 'string' ? disclaimer : disclaimer?.text;
};

export function isStandardReferenceDisclaimer(disclaimer: DisclaimerType): disclaimer is string {
	return typeof disclaimer === 'string';
}

// Limpia HTML y markdown
export const cleanText = (text: string): string => {
	const element = document.createElement('textarea');
	element.innerHTML = text;
	return element.value
		.replace(/<[^>]*>/g, '') // Quita HTML
		.replace(/\*\*?([^*]+)\*\*?/g, '$1') // Quita markdown bold
		.replace(/__?([^_]+)__?/g, '$1') // Quita markdown italic
		.trim();
};

export const handleScrollToDisclaimer = (reference: string) => {
	console.log('handle scroll to disclaimer');

	//Guardamos la posición inicial
	const initialScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

	//Obtenemos todos los legales (se localizan por usar dt)
	const allDts = document.querySelectorAll('dt');
	for (const dt of Array.from(allDts)) {
		//Limpiamos el . que tienen el numero del legal (2.)
		if (dt.textContent?.trim() === `${reference}.`) {
			//Cogemos el legal de la lista que tiene dicha referencia (2)
			const li = dt.closest('li');
			if (li) {
				//Ahora cogemos el mensaje del legal para añadirle el (volver arriba)
				const dd = li.querySelector('dd');
				if (dd && !dd.querySelector('.back-to-top')) {
					const span = document.createElement('span');
					span.className = 'back-to-top';
					span.style.cssText = 'display:block;cursor:pointer;color:inherit;text-decoration:underline;font-weight:bold;';
					span.textContent = '↑ Volver arriba';
					span.onclick = () => {
						//Activamos el auto scroll para volver al legal y desactiamos el autoscroll al pasar 1500ms
						window.scrollTo({
							top: initialScrollPosition,
							behavior: 'smooth',
						});
						span.remove();
					};
					dd.appendChild(span);
				}

				//Obtenemos la posicion del legal en la lista
				const rect = li.getBoundingClientRect();
				//Obtenemos cuanto se ha scrolleado ya para tenerlo en cuenta
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
				//Hacemos scroll automatico con 100 px de margen
				window.scrollTo({
					top: scrollTop + rect.top - 100,
					behavior: 'smooth',
				});
				//Hacemos focus en el legal
				setTimeout(() => {
					li.setAttribute('tabindex', '-1');
					li.focus();
				}, 800);

				return;
			}
		}
	}
};
